import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useCommunityRole } from '@/hooks/use-community-role';
import { SubPageEditor } from '@/components/sub-page-editor';
import { Skeleton } from '@org/ui';

export const Route = createFileRoute('/spaces/$spaceId/pages/new')({
  component: NewSubPage,
});

function NewSubPage() {
  const { spaceId } = Route.useParams();
  const { t } = useTranslation('community');
  const { isAdmin, isModerator, isLoading } = useCommunityRole();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full rounded-2xl" />
      </div>
    );
  }

  if (!isAdmin && !isModerator(spaceId)) {
    return <Navigate to="/spaces/$spaceId" params={{ spaceId }} />;
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('subPages.create')}</h1>
      <SubPageEditor spaceId={spaceId} />
    </div>
  );
}
